import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import * as APIResources from "./modules/api-resources";
import { apiResourceFulfilled } from "./actions";
import {
  APIResourceType
} from "../api";
const reducer = APIResources.reducer;
function getSerializedState(state) {
  return APIResources.getSerializedState(state);
}
function getHasAPIResource(state, resourceType, resourceId) {
  return APIResources.getHasAPIResource(state, resourceType, resourceId);
}
function getAPIResource(state, resourceType, resourceId) {
  return APIResources.getAPIResource(state, resourceType, resourceId);
}
async function fetchJson(url) {
  const response = await fetch(url, {
    headers: { "Content-Type": "application/json" }
  });
  if (response.status === 404)
    return null;
  if (!response.ok)
    throw new Error(response.statusText);
  if (response.headers.get("content-type")?.includes("application/json") !== true) {
    throw new Error(
      `Expected JSON response from "${url}" but got "${response.headers.get("content-type")}"`
    );
  }
  return response.json();
}
function fetchAPIResource(resourceType, resourceId, locale) {
  return async (dispatch, getState) => {
    const state = getState();
    if (getHasAPIResource(state, resourceType, resourceId)) {
      return getAPIResource(state, resourceType, resourceId);
    }
    let resource;
    switch (resourceType) {
      case APIResourceType.Swatch:
        resource = await fetchJson(`/api/makeswift/swatches/${resourceId}`);
        break;
      case APIResourceType.File:
        resource = await fetchJson(`/api/makeswift/files/${resourceId}`);
        break;
      case APIResourceType.Typography:
        resource = await fetchJson(`/api/makeswift/typographies/${resourceId}`);
        break;
      case APIResourceType.GlobalElement:
        resource = await fetchJson(`/api/makeswift/global-elements/${resourceId}`);
        break;
      case APIResourceType.LocalizedGlobalElement: {
        if (locale == null)
          throw new Error("Locale is required to fetch LocalizedGlobalElement");
        resource = await fetchJson(
          `/api/makeswift/localized-global-elements/${resourceId}/${locale}`
        );
        break;
      }
      case APIResourceType.PagePathnameSlice: {
        const url = new URL(`/api/makeswift/page-pathname-slices/${resourceId}`, "http://n");
        if (locale != null)
          url.searchParams.set("locale", locale.toString());
        resource = await fetchJson(url.pathname + url.search);
        break;
      }
      case APIResourceType.Table:
        resource = await fetchJson(`/api/makeswift/tables/${resourceId}`);
        break;
      default:
        resource = null;
    }
    dispatch(apiResourceFulfilled(resourceType, resourceId, resource));
    return resource;
  };
}
function configureStore({ serializedState }) {
  return createStore(reducer, APIResources.getInitialState(serializedState), applyMiddleware(thunk));
}
export {
  configureStore,
  fetchAPIResource,
  getAPIResource,
  getHasAPIResource,
  getSerializedState
};
//# sourceMappingURL=makeswift-api-client.js.map